import propTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import Swal from 'sweetalert2';
import './swal.css';

/**
 * The ConfirmationModal component
 *
 * @param {object} props The component props
 * @param {string} props.title The title of the modal
 * @param {string} props.text The text of the modal
 * @param {string} props.confirmButtonText The text of the confirm button
 * @param {Function} props.onConfirm The function to call when the user confirms the action
 */
/**
 * Renders a confirmation modal dialog.
 *
 * @param {object} props - The component props.
 * @param {Function} props.onConfirm - The callback function to be called when the user confirms the action.
 * @param {string} [props.text] - The text to be displayed in the modal body. If not provided, a default message will be shown.
 * @param {string} [props.title] - The title of the modal. If not provided, a default title will be shown.
 * @param {string} [props.confirmButtonText] - The text to be displayed on the confirm button. If not provided, a default text will be shown.
 * @param {boolean} [props.showCancelButton] - Show the cancel button.
 */
const ConfirmationModal = ({
  onConfirm,
  text,
  title,
  confirmButtonText,
  showCancelButton,
}) => {
  Swal.fire({
    title: title || 'Are you sure?',
    html: ReactDOMServer.renderToString(
      <span>{text || 'This is an alert message'}</span>,
    ),
    showCloseButton: true,
    showCancelButton,
    cancelButtonText: 'Cancel',
    confirmButtonText: confirmButtonText || 'Yes',
    showLoaderOnConfirm: true,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};

ConfirmationModal.propTypes = {
  title: propTypes.string,
  text: propTypes.string,
  confirmButtonText: propTypes.string,
  showCancelButton: propTypes.bool,
};

ConfirmationModal.defaultProps = {
  title: 'Are you sure?',
  showCancelButton: true,
  text: 'This is an alert message',
  confirmButtonText: 'Yes, delete it!',
};

export default ConfirmationModal;
